import React from "react";
import { Container, Grid, Typography } from "@mui/material";
import AnimationFadeIn from "@components/AnimationFadeIn";
import BackgroundImage from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import CardHomeCst from "@components/CardHomeCst";
import ButtonBackPage from "@components/ButtonBackPage";
import { useTranslation } from "react-i18next";
import { useAuth } from "@context/auth";

const SkillBook: React.FC = () => {
  const { t } = useTranslation(["skillBook-page"]);
  const { user } = useAuth();

  const canSeeEnrollments = user?.permissions.includes(
    "fe.external.certificate.enrollments",
  );
  const canSeeCompletions = user?.permissions.includes(
    "fe.external.certificate.completions",
  );

  return (
    <AnimationFadeIn>
      <BackgroundImage
        customWidth="100%"
        customHeight="603px"
        image="section-skillbook.jpg"
        position="absolute"
        fullpage={true}
        zIndex={-1}
      />
      <Breadcrumb />
      <Container maxWidth="xxl" sx={{ position: "relative", zIndex: 1, mt: 2 }}>
        <HeroCst title={t("hero-title")} description={t("hero-description")} />
        <ButtonBackPage />
        {canSeeEnrollments || canSeeCompletions ? (
          <Grid container spacing={3} sx={{ mt: 3 }}>
            {canSeeEnrollments && (
              <Grid item xs={12} md={6}>
                <CardHomeCst
                  image="section-skillbook-esterna.jpg"
                  title={t("card-title-enrollments")}
                  description=""
                  secondaryBtnLabel={t("manage")}
                  to="enrollments"
                />
              </Grid>
            )}
            {canSeeCompletions && (
              <Grid item xs={12} md={6}>
                <CardHomeCst
                  image="section-skillbook-consuntivazione.jpg"
                  title={t("card-title-completions")}
                  description=""
                  secondaryBtnLabel={t("manage")}
                  to="completions"
                />
              </Grid>
            )}
          </Grid>
        ) : (
          <Typography mt={5} mb={5}>
            {t("no_permissions")}
          </Typography>
        )}
      </Container>
    </AnimationFadeIn>
  );
};

export default SkillBook;
